import { PII } from '@locales/id/messages';

/** The server masks personal data for accounts without `pii.read` ("B•••", "a•••@contoh.go.id"). */
export const isMasked = (v: string | null | undefined) => !!v && v.includes('•');

/**
 * A personal value as the server sent it (a name, an email). A masked one keeps its place in the layout and says
 * why it is hidden (tooltip, and in words for screen readers instead of reading the dots out); empty shows "–".
 */
export function Masked({ value, className }: { value: string | null | undefined; className?: string }) {
  if (!value) return <span className={className}>–</span>;
  if (!isMasked(value)) return <span className={className}>{value}</span>;
  return (
    <span className={`masked ${className ?? ''}`} title={PII.masked}>
      <span aria-hidden="true">{value}</span>
      <span className="sr-only">{PII.maskedShort}</span>
    </span>
  );
}
